import moment from 'moment';
import React, { Component, Fragment } from 'react';
import { get } from '../../../server/actions';
import {_addNotificationError } from '../../../server/util';
import { getLoginDistrictInfo } from '../../../server/utilDistrict';
import masterReportIcon from './../../../assets/img/mm/table-list-solid-full.svg';
import download from 'downloadjs';
class MasterTrackingLog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: new Date(),
            endDate: new Date(),
            userInfo: getLoginDistrictInfo(),
        }
    }
    componentWillMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }
    getMasterTrackingLogReport = () => {
        const districtID = this.state.userInfo.districtId;
        const verificationYear = this.props.selectedSchoolYear;
        const schoolId = this.props.selectedSchoolId;
        this.setState({ loading: true });
        const schoolParam = schoolId ? `schoolId=${schoolId}&` : '';       
        get(`/verification/reports/masterTrackingLog/export/${districtID}/${verificationYear}?${schoolParam}format=xls&access_token=`
        ).then((response) => {
            if (!response.ok) {
                return response.json().then((errorResponse) => {
                    throw new Error(
                        errorResponse.statusMessage ||
                        errorResponse.errorMessage ||
                        "No data found."
                    );
                });
            }
            return response.blob();
        })
        .then((blob) => {
            // Download XLS file instead of opening blob in browser
            download(
                blob,
                `MasterTrackingLogReport_${verificationYear}.xls`,
                "application/vnd.ms-excel"
            );
            this.setState({ loading: false });
        })
        .catch((error) => {
            console.log("getMasterTrackingLogReport error:", error);
            const msg =
                typeof error === "string"
                    ? error
                    : error.message || "No data found.";
            _addNotificationError(msg, this.props);
            this.setState({ loading: false });
        });
    };
    render() {
        return (
            <Fragment>
                <div className="reportCard reportCard-margin">
                    <div className="reportCard-body">
                        <div className="reportCard-widget" style={{ minHeight: '100px' }}>
                            <div className="reportCard-widget-title-wrapper">
                                <div className="reportCard-widget-date-primary">
                                    <img src={masterReportIcon} style={{ width: '40px', height: '40px' }} />
                                </div>
                                <div className="reportCard-widget-meeting-info">
                                    <span className="reportCard-widget-pro-title color-3"><b>Master Tracking Log Report</b></span>
                                    <p>Student-By-Student roster</p>
                                </div>
                            </div>
                            <div className='reportCard-widget-meeting-action' style={{
                                                                                        marginLeft: 'auto',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center' }}>
                                    <button type='button' className="btn btn-success btn-sm" style={{ margin: '0px' }} onClick={() => {
                                        this.getMasterTrackingLogReport()
                                    }}><i className="fa fa-file-excel-o"></i> Excel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
export default MasterTrackingLog;


// WEBPACK FOOTER //
// ./src/components/District/VerificationReport/masterTrackingLog.js